import React, { useEffect, useState } from 'react';
import { get, isEmpty } from 'lodash';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useMediaQuery } from 'react-responsive/src';
import { AwardActions } from 'modules/awards/action';
import { AwardSelector } from 'modules/awards/selector';
import { HomeActions } from 'modules/home/actions';
import { HomeSelector } from 'modules/home/selector';
import { ProjectActions } from 'modules/project/actions';
import { AboutActions } from 'modules/about/actions';
import { ProjectSelector } from 'modules/project/selector';
import { ProjectBrowserActions } from 'modules/projectBrowser/actions';
import { AboutPageSelector } from 'modules/about/selector';
import { ProjectBrowserSelector } from 'modules/projectBrowser/selector';
import { PageLoader } from 'components/molecules/pageLoader';
import NewsSection from 'components/templates/newsSection';
import ProjectAmenitiesViewControl from 'components/organisms/projectAmenitiesViewControl';
import ProjectDetailsBanner from 'components/organisms/projectDetailsBanner';
import Award from 'components/templates/awards';
import FooterSection from 'components/templates/footer';
import NeighbourhoodGuide from 'components/templates/neighborhoodGuide';
import PageTemplate from 'components/templates/pageTemplate';
import ProductBrowser from 'components/templates/productBrowser';
import ImageGallerySection from 'components/templates/imageGallerySection';
import RecommendedSection from 'components/templates/recommendedSection';
import { VirtualTourSection } from 'components/templates/virtualTourSection';
import OurHomesDifferences from 'components/templates/ourHomesDifference';
import { ContactUsSection } from 'components/templates/contactUsSection';
import { CmsPagesSelector } from 'modules/cmsPages/selector';
import { CmsPagesActions } from 'modules/cmsPages/actions';
import { CmsDetailsSelector } from 'modules/cmsDetails/selector';
import { CmsDetailsActions } from 'modules/cmsDetails/actions';
import { GetInTouchModal } from 'components/templates/getInTouchModal';
import { DownloadBrochureModal } from 'components/templates/downloadBrochureModal';
import { ShareModal } from 'components/templates/shareModal';
import OurHomesMachineCraft from 'components/templates/machineCraft';
import EDesignSection from 'components/templates/eDesign';
import { RouteNames } from 'router';
import ConstructionGallerySection from 'components/templates/constructionGallery';
import RenderSEO from 'components/atoms/renderSEO';
import { ProductBrowserAction } from 'modules/productBrowser/actions';
import { HeaderButtons } from 'components/atoms/headerButtons';
import CompletedProjectsSection from 'components/templates/completedProjectsSection';
import { PROJECT_FILE_DOWNLOAD_URL } from 'config/env';
import Testimonial from 'components/templates/testimonial';
import { VideoActions } from 'modules/videos/action';
import { VideosSelector } from 'modules/videos/selector';
import { ProjectAnnouncementsSection } from 'components/templates/projectAnnouncementsSection';
import { FooterActions } from 'modules/footerLink/actions';
import { FooterSelector } from 'modules/footerLink/selector';

const ProjectDetails = props => {
  const {
    isLoading,
    getVerticals,
    verticals,
    verticalId,
    getContactDetails,
    contact,
    getSiteSettings,
    siteSettings,
    getAnnouncements,
    announcements,
    getProjectDetails,
    getParticularProductDetails,
    projectDetails,
    getProjects,
    recommendedList,
    awardData,
    getAwardData,
    particularProductDetails,
    getNeighbourhoodGuide,
    neighbourhoodDetails,
    getGalleryForProject,
    gallery,
    getPageData,
    ourDifferenceData,
    cmsDetailsData,
    getCmsDetailsData,
    machineCraftSection,
    eDesign,
    newsData,
    getConstructionGalleryForProject,
    constructionGallery,
    getAboutNews,
    getProductBrowser,
    footerLink,
    getFooterLinkData,
    getBannerData,
    getProjectBrochure,
    projectBrochure,
    getVideosData,
    videosData,
  } = props;
  const project_url_slug = props.match.params.projectSlug;
  const isMobile = useMediaQuery({ query: '(max-device-width: 560px)' });

  let [theme, setTheme] = useState(isMobile ? 'dark-theme' : 'light-theme');
  const [isGetInTouchModalOpen, setIsGetInTouchModalOpen] = useState(false);
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [mapView, setMapView] = useState(false);
  const type = 'project';

  useEffect(() => {
    getProjectDetails(project_url_slug);
    getAnnouncements(verticalId, project_url_slug);
    getContactDetails();
    getVerticals();
    getSiteSettings();
    getNeighbourhoodGuide();
    getProjects(verticalId);
    getPageData();
    getFooterLinkData();
    getAboutNews();
    getCmsDetailsData();
    getParticularProductDetails(project_url_slug);
    getGalleryForProject(project_url_slug);
    getAwardData(verticalId, project_url_slug);
    getConstructionGalleryForProject(project_url_slug);
    getProductBrowser();
    getBannerData();
    getProjectBrochure(project_url_slug);
    getVideosData(verticalId, project_url_slug, type);
  }, [project_url_slug, verticalId]);

  const hasData = () => {
    return (
      siteSettings &&
      verticals &&
      neighbourhoodDetails &&
      projectDetails &&
      machineCraftSection &&
      cmsDetailsData &&
      footerLink
    );
  };

  if (isLoading) {
    return <PageLoader isMobile={isMobile} />;
  }

  if (!hasData()) {
    return null;
  }

  const projectName = get(projectDetails, 'project.title', '');
  const metaTagSEO = projectDetails.project.metaTagSEO;

  const {
    machineCraft: machineCraftOverlay,
    customiseWithEDesign,
  } = cmsDetailsData;

  // Get in touch
  const closeGetInTouchModal = () => {
    setIsGetInTouchModalOpen(false);
  };
  // Share
  const closeShareModal = () => {
    setIsShareModalOpen(false);
  };

  const updateMapView = (theme, view) => {
    setTheme(theme);
    setMapView(view);
  };
  const CampaignCode = contact.campaignCode ? contact.campaignCode : '';
  let project = projectDetails && projectDetails.project;
  const CampaignBrochureCode = project.brochure_campaign_code
    ? project.brochure_campaign_code
    : '';
  let pdfUrl =
    project.brochure && `${PROJECT_FILE_DOWNLOAD_URL}${project.brochure}`;

  const componentList = [
    ...(!isEmpty(projectDetails)
      ? [
          {
            component: ProjectDetailsBanner,
            data: { projectDetails },
            theme: isMobile ? 'dark-theme' : 'light-theme',
            sectionId: 'banner',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Homes',
                breadcrumbLink: RouteNames.homes,
              },
              {
                breadcrumbName: `${projectName}`,
                breadcrumbLink: '#',
              },
            ],
          },
        ]
      : []),
    ...(!isEmpty(announcements)
      ? [
          {
            component: ProjectAnnouncementsSection,
            data: {
              announcements,
              onGetInTouchClick: setIsGetInTouchModalOpen,
              checkForCTAButton: true,
            },
            sectionId: 'announcements',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Homes',
                breadcrumbLink: RouteNames.homes,
              },
              {
                breadcrumbName: projectName,
                breadcrumbLink: '#',
              },
              {
                breadcrumbName: 'Announcements',
                breadcrumbLink: '#',
              },
            ],
            theme: 'dark-theme',
            sectionName: 'announcement-section',
          },
        ]
      : []),
    ...(!isEmpty(gallery)
      ? [
          {
            component: ImageGallerySection,
            data: {
              images: gallery,
            },
            theme: 'dark-theme',
            sectionId: 'gallery',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Homes',
                breadcrumbLink: RouteNames.homes,
              },
              {
                breadcrumbName: projectName,
                breadcrumbLink: '#',
              },
              {
                breadcrumbName: `Gallery`,
                breadcrumbLink: '#',
              },
            ],
          },
        ]
      : []),
    ...(!isEmpty(projectDetails.project.virtualTours)
      ? [
          {
            component: VirtualTourSection,
            data: {
              data: projectDetails.project.virtualTours || [],
            },
            theme: isMobile ? 'dark-theme' : 'light-theme',
            sectionId: 'virtual-tours',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Homes',
                breadcrumbLink: RouteNames.homes,
              },
              {
                breadcrumbName: projectName,
                breadcrumbLink: '#',
              },
              {
                breadcrumbName: `360\u00B0 Tour`,
                breadcrumbLink: '#',
              },
            ],
          },
        ]
      : []),
    ...(!isEmpty(particularProductDetails)
      ? [
          {
            component: ProductBrowser,
            data: {
              productData: particularProductDetails,
              projectDetails: projectDetails.project,
              breadcrumb: projectName,
            },
            sectionId: 'products',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Homes',
                breadcrumbLink: RouteNames.homes,
              },
              {
                breadcrumbName: projectName,
                breadcrumbLink: '#',
              },
              {
                breadcrumbName: `Product Browser`,
                breadcrumbLink: '#',
              },
            ],
            theme: 'dark-theme',
          },
        ]
      : []),
    ...(!isEmpty(ourDifferenceData)
      ? [
          {
            component: OurHomesDifferences,
            data: {
              ourDifferenceData,
              cmsDetailsData,
            },
            sectionId: 'our-differences',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Homes',
                breadcrumbLink: RouteNames.homes,
              },
              {
                breadcrumbName: projectName,
                breadcrumbLink: '#',
              },
              {
                breadcrumbName: 'Our Differences',
                breadcrumbLink: '#',
              },
            ],
            theme: 'light-theme',
          },
        ]
      : []),
    ...(!isEmpty(neighbourhoodDetails.list)
      ? [
          {
            component: NeighbourhoodGuide,
            data: {
              data: neighbourhoodDetails,
              updateMapView,
              mapView,
              breadcrumb: projectName,
            },
            sectionId: 'neighbourhood-guide',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Homes',
                breadcrumbLink: RouteNames.homes,
              },
              {
                breadcrumbName: projectName,
                breadcrumbLink: '#',
              },
              {
                breadcrumbName: `Neighbourhood Guide`,
                breadcrumbLink: '#',
              },
            ],
            theme: isMobile ? 'dark-theme' : 'light-theme',
          },
        ]
      : []),
    ...(!isEmpty(projectDetails.project_amenities)
      ? [
          {
            component: ProjectAmenitiesViewControl,
            data: {
              data: projectDetails,
              pdfUrl,
            },
            theme: !isMobile ? 'light-theme' : 'dark-theme',
            sectionId: 'amenities',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Homes',
                breadcrumbLink: RouteNames.homes,
              },
              {
                breadcrumbName: projectName,
                breadcrumbLink: '#',
              },
              {
                breadcrumbName: `Amenities`,
                breadcrumbLink: '#',
              },
            ],
          },
        ]
      : []),
    ...(!isEmpty(projectBrochure)
      ? [
          {
            component: CompletedProjectsSection,
            data: {
              completedProjects: projectBrochure,
              sectionHeading: 'Project Details',
            },
            theme: 'light-theme',
            sectionId: 'completed-projects',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Homes',
                breadcrumbLink: RouteNames.homes,
              },
              {
                breadcrumbName: projectName,
                breadcrumbLink: '#',
              },
              {
                breadcrumbName: 'Project Details',
                breadcrumbLink: '#',
              },
            ],
          },
        ]
      : []),
    ...(!isEmpty(constructionGallery)
      ? [
          {
            component: ConstructionGallerySection,
            data: {
              constructionGallery,
            },
            theme: 'light-theme',
            sectionId: 'construction-gallery',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Homes',
                breadcrumbLink: RouteNames.homes,
              },
              {
                breadcrumbName: projectName,
                breadcrumbLink: '#',
              },
              {
                breadcrumbName: `Construction Gallery`,
                breadcrumbLink: '#',
              },
            ],
          },
        ]
      : []),
    ...(!isEmpty(machineCraftSection)
      ? [
          {
            component: OurHomesMachineCraft,
            data: {
              machineCraftSection,
              machineCraftOverlay,
            },
            sectionId: 'machine-craft',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Homes',
                breadcrumbLink: RouteNames.homes,
              },
              {
                breadcrumbName: projectName,
                breadcrumbLink: '#',
              },
              {
                breadcrumbName: 'Machine-craft',
                breadcrumbLink: '#',
              },
            ],
            theme: 'light-theme',
          },
        ]
      : []),
    ...(!isEmpty(eDesign)
      ? [
          {
            component: EDesignSection,
            data: {
              eDesign,
              customiseWithEDesign,
              togglePadding: !!machineCraftSection,
            },
            sectionId: 'eDesign',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Homes',
                breadcrumbLink: RouteNames.homes,
              },
              {
                breadcrumbName: projectName,
                breadcrumbLink: '#',
              },
              {
                breadcrumbName: 'eDesign',
                breadcrumbLink: '#',
              },
            ],
            theme: 'light-theme',
          },
        ]
      : []),
    ...(!isEmpty(awardData)
      ? [
          {
            component: Award,
            sectionId: 'awards',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Homes',
                breadcrumbLink: RouteNames.homes,
              },
              {
                breadcrumbName: projectName,
                breadcrumbLink: '#',
              },
              {
                breadcrumbName: 'Awards',
                breadcrumbLink: '#',
              },
            ],
            theme: 'dark-theme',
            data: awardData,
          },
        ]
      : []),
    ...(!isEmpty(videosData)
      ? [
          {
            component: Testimonial,
            sectionId: 'videos',
            theme: 'dark-theme',
            data: { testimonialData: videosData, type: 'videos' },
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Homes',
                breadcrumbLink: RouteNames.homes,
              },
              {
                breadcrumbName: projectName,
                breadcrumbLink: '#',
              },
              {
                breadcrumbName: 'Videos',
                breadcrumbLink: '#',
              },
            ],
          },
        ]
      : []),
    ...(!isEmpty(newsData.result_news_data)
      ? [
          {
            component: NewsSection,
            data: {
              newsData,
              sectionHeading: 'News',
              overlayButtonTextDesktop: 'SEE ALL',
              overlayButtonTextMobile: 'VIEW ALL',
              showNotificationButton: true,
              toggleId: true,
            },
            sectionId: 'publications',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Music & Events',
                breadcrumbLink: '#',
              },
              {
                breadcrumbName: 'News',
                breadcrumbLink: '#',
              },
            ],
            theme: 'dark-theme',
          },
        ]
      : []),
    {
      component: ContactUsSection,
      data: {
        contact,
        verticals,
        verticalId,
        projectName,
        callPostLeadAPI: true,
      },
      location: props,
      sectionId: 'contact',
      breadcrumbList: [
        {
          breadcrumbName: 'TotalEnvironment',
          breadcrumbLink: RouteNames.landing,
        },
        {
          breadcrumbName: 'Homes',
          breadcrumbLink: RouteNames.homes,
        },
        {
          breadcrumbName: projectName,
          breadcrumbLink: '#',
        },
        {
          breadcrumbName: 'Contact Us',
          breadcrumbLink: '#',
        },
      ],
      theme: 'light-theme',
    },
    ...(!isEmpty(recommendedList)
      ? [
          {
            component: RecommendedSection,
            sectionId: 'recommended',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'Homes',
                breadcrumbLink: RouteNames.homes,
              },
              {
                breadcrumbName: projectName,
                breadcrumbLink: '#',
              },
              {
                breadcrumbName: 'Recommended',
                breadcrumbLink: '#',
              },
            ],
            theme: 'dark-theme',
            data: {
              data: recommendedList,
              type: 'projectDetails',
            },
          },
        ]
      : []),
    {
      component: FooterSection,
      theme: 'dark-theme',
      sectionId: 'te-links',
      breadcrumbList: [
        {
          breadcrumbName: 'TotalEnvironment',
          breadcrumbLink: RouteNames.landing,
        },
        {
          breadcrumbName: 'Homes',
          breadcrumbLink: RouteNames.homes,
        },
        {
          breadcrumbName: projectName,
          breadcrumbLink: '#',
        },
        {
          breadcrumbName: 'Links',
          breadcrumbLink: '#',
        },
      ],
      data: { siteSettings, footerLink },
    },
  ];

  return (
    <div>
      <RenderSEO metaTags={metaTagSEO} currentRouteName={project_url_slug} />
      <PageTemplate
        theme={theme}
        componentList={componentList}
        updateTheme={e => setTheme(e)}
        verticals={verticals}
        siteSettings={siteSettings}
        campaignCode={CampaignCode}
        projectInterested={projectName}
        salesEmail={contact.email}
        headerButtons={
          <HeaderButtons
            shareTheme={'dark'}
            getInTouchTheme={'light'}
            setIsModalOpen={setIsGetInTouchModalOpen}
            setIsShareModalOpen={setIsShareModalOpen}
          />
        }
      />
      <GetInTouchModal
        isOpen={isGetInTouchModalOpen}
        onClosePress={closeGetInTouchModal}
        campaignCode={CampaignCode}
        projectInterested={projectName}
        salesEmail={contact.email}
        callPostLeadAPI={true}
        verticalId={verticalId}
      />
      <ShareModal
        isOpen={isShareModalOpen}
        onClosePress={closeShareModal}
        callPostLeadAPI={true}
      />
    </div>
  );
};

const mapStateToProps = state => {
  const verticalKey = 'homes';

  return {
    isLoading:
      ProjectSelector.isDetailsPageLoading(state) ||
      VideosSelector.isLoading(state) ||
      FooterSelector.isLoading(state) ||
      ProjectSelector.getAnnouncementsLoading(state),
    awardData: AwardSelector.getAwardData(state),
    gallery: ProjectSelector.getGallery(state),
    siteSettings: HomeSelector.getSiteSettings(state),
    verticals: HomeSelector.getVerticals(state),
    verticalId: HomeSelector.getVerticalIdForKey(verticalKey),
    contact: HomeSelector.getContactForProject(state),
    newsData: AboutPageSelector.getAboutNews(state, 'News', 'homes'),
    announcements: ProjectSelector.getAnnouncements(state),
    footerLink: FooterSelector.getFooterData(state),
    neighbourhoodDetails: ProjectSelector.getNeighbourhoodGuide(state),
    particularProductDetails: ProjectBrowserSelector.getParticularProductDetails(
      state
    ),
    ourDifferenceData: CmsPagesSelector.getOurDifferenceSection(
      state,
      'our-difference',
      'The Total Environment Difference'
    ),
    cmsDetailsData: CmsDetailsSelector.getCmsDetailsData(state),
    projectDetails: ProjectBrowserSelector.getProjectDetails(state),
    machineCraftSection: CmsPagesSelector.getCmsPages(
      state,
      'Machine-craft',
      false
    ),
    eDesign: CmsPagesSelector.getCmsPages(
      state,
      'Customise With eDesign',
      false
    ),
    recommendedList: ProjectBrowserSelector.getRecommendedProject(state),
    constructionGallery: ProjectSelector.getConstructionGallery(state),
    projectBrochure: ProjectSelector.getProjectBrochure(state),
    videosData: VideosSelector.getVideosData(state),
  };
};

const mapDispatchToProps = dispatch => {
  const {
    getVerticals,
    getSiteSettings,
    getContactDetails,
    getBannerData,
  } = HomeActions;
  const { getAwardData } = AwardActions;
  const { getPageData } = CmsPagesActions;
  const {
    getProjectDetails,
    getParticularProductDetails,
  } = ProjectBrowserActions;
  const {
    getGalleryForProject,
    getNeighbourhoodGuide,
    getProjects,
    getConstructionGalleryForProject,
    getProjectBrochure,
    getAnnouncements,
  } = ProjectActions;
  const { getVideosData } = VideoActions;
  const { getCmsDetailsData } = CmsDetailsActions;
  const { getFooterLinkData } = FooterActions;
  const { getProductBrowser } = ProductBrowserAction;
  const { getAboutNews } = AboutActions;
  return bindActionCreators(
    {
      getContactDetails,
      getVerticals,
      getSiteSettings,
      getAwardData,
      getProjectDetails,
      getPageData,
      getParticularProductDetails,
      getNeighbourhoodGuide,
      getGalleryForProject,
      getProjects,
      getCmsDetailsData,
      getConstructionGalleryForProject,
      getProductBrowser,
      getBannerData,
      getProjectBrochure,
      getVideosData,
      getAnnouncements,
      getFooterLinkData,
      getAboutNews,
    },
    dispatch
  );
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ProjectDetails)
);
